import React from 'react'
import PageLoader from '../components/PageLoader'

type Props = {
    children: React.ReactNode
}

function PublicRouteWrapper({ children }: Props) {
    return (
        <PageLoader>
            {children}
        </PageLoader>
    )
}

export default PublicRouteWrapper
